import { render, staticRenderFns } from "./ProblemPushReportModal.vue?vue&type=template&id=646dcb98&scoped=true"
import script from "./ProblemPushReportModal.vue?vue&type=script&lang=js"
export * from "./ProblemPushReportModal.vue?vue&type=script&lang=js"
import style0 from "./ProblemPushReportModal.vue?vue&type=style&index=0&id=646dcb98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646dcb98",
  null
  
)

export default component.exports